export default "__VITE_ASSET__BRsNU2yY__"